// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer {
  background-color: #2d2d2d;
  padding: 10px 12px;
}
footer .container {
  padding: 0;
}
footer h4,
footer p,
footer li {
  color: #fff;
}
footer h4 {
  font-weight: normal;
  font-size: 14px;
  font-family: "Open Sans";
}
footer img {
  height: 30px;
}

.disclaimer-more {
  display: none;
}

.disclaimer-more.open {
  display: block;
}

.info-footer {
  text-align: center;
}
.info-footer a {
  color: #ecc23c;
}
.info-footer button {
  background-color: transparent;
  border: 0;
  color: #fff;
  text-transform: uppercase;
  font-weight: bold;
  letter-spacing: 1px;
  position: relative;
}
.info-footer button::after {
  content: "";
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 7px solid #fff;
  position: absolute;
  bottom: -12px;
  left: calc(50% - 5px);
}
.info-footer .disclaimer-more ul {
  list-style-type: none;
}

.credits h4 {
  white-space: nowrap;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
